import { Box, ColorOptions, convertHexToRGBA, mobileNumber, Spacer, Text } from '@jfs/ui-new'
import { email, notRequired } from '@jfs/ui-new/src/utils/validations'
import { required } from '@jfs/utils'
import { Platform } from 'react-native'
import { name } from '../../../../../src/util/regex'
import { SvgImage } from '../../../../comps/SvgImage'
import { Colors } from '../../../../util/util'
import { AddEmail } from './AddEmail'
import { ContactsModalInput } from './ContactsModalInput'
import { DepartmentDropdown } from './DepartmentDropdown'
import { TextInputWithLabelOnBorder } from './TextInputWithLabelOnBorder'

export const fieldCheckboxName = 'checkBoxFormData'

export const DropdownMobileData = [
  {
    id: '1',
    value: 'Admin',
    iconId: 'ProfileIconFilled',
    desc: 'Access to all transaction data,  notification management &  manage users',
  },
  {
    id: '2',
    value: 'Cashier',
    iconId: 'ManageUsersIcon',
    desc: 'Access to all transaction data, notification management',
  },
  {
    id: '3',
    value: 'Other',
    iconId: 'ManageUsersIcon',
    desc: 'Customized  permissions',
  },
]

interface formDataInterface {
  dropdownValue: string
  onDropdownValueChange: (val: string) => void
  accessRightsData: any
  isEditScreen: boolean
  onSelectAllChange: (value: any, role: string) => void
  expandView?: boolean
  checkedArray: any
  updateCheckedArray: (index: number, val: any) => void
  rightComponent?: any
  leftComponent?: any
  allEditable?: boolean
  addEmailEnabled?: boolean
  onPressAddEmail?: any
}

const leftComponent = () => {
  return (
    <Box>
      <Text fontFamily="JioType-Medium" color={Colors.BLACK_14 as ColorOptions} fontSize={16}>
        +91
      </Text>
    </Box>
  )
}
const rightComponent = () => {
  return (
    <Box
      backgroundColor={convertHexToRGBA(Colors.PRIMARY, 16) as ColorOptions}
      height={35}
      ph={8}
      borderRadius={5}
      flexDirection="row"
      align="center"
      justify="center">
      <Box top={2}>
        <SvgImage imageName="ContactsIcon" color={Colors.SECONDARY} />
      </Box>
      <Spacer direction="horizontal" size={2} />
      <Text fontFamily="JioType-Medium" color={'SECONDARY'} fontSize={12}>
        Contacts
      </Text>
    </Box>
  )
}

export const formData = ({
  dropdownValue,
  onDropdownValueChange,
  accessRightsData,
  isEditScreen,
  onSelectAllChange,
  expandView,
  checkedArray,
  updateCheckedArray,
  allEditable,
  addEmailEnabled = false,
  onPressAddEmail,
}: formDataInterface) => {
  const isMobile = Platform.OS !== 'web'
  // console.log('checkedArray', checkedArray)
  // console.log('accessRightsData', accessRightsData)
  // const checkBoxFormData = accessRightsData?.map((item: any, index: any) => {
  //   // console.log('item type', item)
  //   return {
  //     fieldName: `${fieldCheckboxName}_` + index,
  //     ComponentName: AcessRightsCheckbox,
  //     heading: item.type && item.type.toLowerCase() !== 'null' ? item.type : 'Miscellaneous',
  //     initialCheckBoxData: item.data,
  //     updateCheckBoxData: () => { },
  //     expandView: expandView,
  //     onSelect: (val: any) => updateCheckedArray(index, val),
  //   }
  // })
  //console.log('isEditScreen', isEditScreen)
  return [
    {
      verticalSpacing: 0,
      formItems: [
        {
          fieldName: 'mobile',
          ComponentName: ContactsModalInput,
          label: 'Mobile Number',
          disabled: isEditScreen,
          validationSchema: mobileNumber,
          maxLength: 10,
          rightComponent: rightComponent(),
          leftComponent: leftComponent(),
          fontSize: 16,
          selectionColor: Colors.PRIMARY,
        },
        {
          fieldName: 'spacer',
          ComponentName: Spacer,
          direction: 'vertical',
          size: 25,
        },
        {
          fieldName: 'userName',
          placeholder: 'Name',
          label: 'Name',
          ComponentName: TextInputWithLabelOnBorder,
          height: 48,
          validationSchema: name,
          disabled: isEditScreen,
          editable: !isEditScreen,
          maxLength: 30,
          fontSize: 16,
          tintColor: 'BORDER_COLOR' as ColorOptions,
          placeholderTextColor: convertHexToRGBA('A6A6A6', 50) as ColorOptions,
          bottomLineColor: convertHexToRGBA('#7F7F7F', 50) as ColorOptions,
          selectionColor: Colors.PRIMARY,
        },
        {
          fieldName: 'spacer',
          ComponentName: Spacer,
          direction: 'vertical',
          size: 25,
        },
        {
          fieldName: 'email',
          ComponentName: AddEmail,
          isEditScreen: isEditScreen,
          addEmailEnabled: addEmailEnabled,
          onPressAddEmail: onPressAddEmail,
          validationSchema: email,
          placeholder: 'Email',
          height: 48,
          disabled: isEditScreen,
          editable: !isEditScreen,
          maxLength: 40,
          fontSize: 16,
          label: 'Email',
          tintColor: 'BORDER_COLOR' as ColorOptions,
          placeholderTextColor: convertHexToRGBA('A6A6A6', 50) as ColorOptions,
          bottomLineColor: convertHexToRGBA('#7F7F7F', 50) as ColorOptions,
          selectionColor: Colors.PRIMARY,
        },
        // {
        //   fieldName: 'email',
        //   placeholder: 'Email',
        //   ComponentName: TextInputWithLabelOnBorder,
        //   height: 48,
        //   validationSchema: optionalEmail,
        //   disabled: isEditScreen,
        //   editable: !isEditScreen,
        //   maxLength: 40,
        //   fontSize: 16,
        //   label: 'Email',
        //   tintColor: 'BORDER_COLOR' as ColorOptions,
        //   placeholderTextColor: convertHexToRGBA('A6A6A6', 50) as ColorOptions,
        //   bottomLineColor: convertHexToRGBA('#7F7F7F', 50) as ColorOptions,
        // },
        {
          fieldName: 'spacer',
          ComponentName: Spacer,
          direction: 'vertical',
          size: 25,
        },
        {
          fieldName: 'role',
          ComponentName: DepartmentDropdown,
          placeHolder: dropdownValue === 'Choose role' ? 'Select role' : 'Role',
          data: DropdownMobileData,
          dropDownContentFontSize: 12,
          disabled: isEditScreen,
          editable: !isEditScreen,
          isEditScreen: isEditScreen,
          dropdownWidth: 300,
          minWidth: 300,
          onChange: (val: any) => onDropdownValueChange(val),
          value: dropdownValue === 'Choose role' ? null : dropdownValue,
          validationSchema: dropdownValue ? notRequired : required,
          onSelectAll: (value: boolean, role: string) => onSelectAllChange(value, role),
          //checkBoxFormData: checkBoxFormData,
          checkedArray: checkedArray,
          accessRightsData: accessRightsData,
          updateCheckedArray: updateCheckedArray,
          expandView: expandView,
          allEditable: allEditable,
        },
        {
          fieldName: 'spacer',
          ComponentName: Spacer,
          direction: 'vertical',
          size: 25,
        },
        // {
        //   fieldName: 'SelectAll',
        //   ComponentName: SelectAll,
        //   heading: staticStrings.SelectAll,
        //   text: staticStrings.access_rights,
        //   accessRightsData: accessRightsData,
        //   onChange: (value: boolean) => onSelectAllChange(value),
        //   checkedArray: checkedArray,
        // },
        // ...checkBoxFormData,
      ],
    },
  ] as Array<any>
}
